import {useBreakpoints, createGlobalState, useMediaQuery} from '@vueuse/core'

export enum Breakpoint {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
}

export const useResponsive = createGlobalState(() => {
  const breakpoints = useBreakpoints({
    [Breakpoint.Small]: 640,
    [Breakpoint.Medium]: 768,
    [Breakpoint.Large]: 1024,
    [Breakpoint.XLarge]: 1280,
  })

  const currentBreakpoint = breakpoints.active()

  function isSmallerThan(breakpoint: Breakpoint) {
    return breakpoints.smaller(breakpoint)
  }
  const isSmallerThanLarge = breakpoints.smaller(Breakpoint.Large)

  function isLargerThan(breakpoint: Breakpoint) {
    return breakpoints.greater(breakpoint)
  }

  function isBetween(min: Breakpoint, max: Breakpoint) {
    return breakpoints.between(min, max)
  }

  const isCoarsePointer = useMediaQuery('(pointer: coarse)')
  const canHover =  useMediaQuery('(hover: hover) and (pointer: fine)')

  return {
    currentBreakpoint,
    isSmallerThan,
    isSmallerThanLarge,
    isLargerThan,
    isBetween,
    isCoarsePointer,
    canHover,
  }
})
